import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import { appellColumns, appellFields, appellDefault } from "@/lib/entities";
import { Megaphone } from "lucide-react";

export default function Appellthemen() {
  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Verwaltung"
        title="Appellthemen"
        description="Themen und Inhalte für Appelle – mit Datum, Thema und ausführlichem Inhalt."
        icon={Megaphone}
      />
      <div className="p-8">
        <RecordsSection
          endpoint="/appellthemen"
          columns={appellColumns}
          fields={appellFields}
          makeDefault={appellDefault()}
          createLabel="Appellthema erstellen"
          emptyLabel="Keine Appellthemen vorhanden"
          testidPrefix="appell"
          dateSortKey="datum"
        />
      </div>
    </div>
  );
}
